import { useIntercom } from '~/hooks/useIntercom';
import { AnalyticsEvent, analyticsService } from '~/services/analytics';

export const useSupportChat = (source: string) => {
  const { openMessenger } = useIntercom();

  const openSupportChat = () => {
    analyticsService.track(AnalyticsEvent.CONTACT_SUPPORT_BUTTON_CLICKED, {
      from: source,
    });
    openMessenger();
  };

  return { openSupportChat };
};
